module.exports = __webpack_public_path__ + "img/kr.60fde7fc.svg";